import { getBaseUrlB2B } from "../AuthService/BaseURLS";
import { axiosWithToken } from "../AuthService/AxiosToken";
import download from "downloadjs";
export function printClaim (claimID,config) {
    return new Promise((resolve, reject) => {
        axiosWithToken.get(getBaseUrlB2B() + "/claim/provider/print?claimId="+ claimID, config )
            .then(response => {
                // The response.data now contains the blob data
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                let fileName = new Date().toLocaleDateString("en-GB").replace(/\//g, '_') +`Claim-${claimID}.pdf`;
                download(blob, fileName );      
                resolve("File Downloaded Successfully");
            })
            .catch(error => {
                reject(error)
            })
    })
}